export type GenericButtonClickEventProductObject = {
  [key: string]: { ID: string }[]
}

export type TrialButtonClickEventProductObject = {
  trial: { ID: string }[]
}

export type DownloadButtonClickEventProductObject = {
  downloaded: { ID: string }[]
}